<template>
  <div>
    <slot name="activator" v-bind="{ toggle }">
      <v-btn flat :color="themes.candidate.light.secondary" @click="toggle">
        Update location
      </v-btn>
    </slot>
    <v-dialog
      :value="locationDialog"
      v-if="value.status !== 'Withdrawn' && value.opportunity.locations"
      max-width="40%"
      absolute
      lazy
    >
      <v-card>
        <v-card-title :class="themes.candidate.light.dialogTitle">
          <div class="title">
            Select the location(s) that would you like to apply to
          </div>
        </v-card-title>
        <v-card-text>
          <v-select
            label="Application Locations"
            v-model="selectLocation"
            :color="themes.candidate.light.input"
            :items="value.opportunity.locations"
            hint="Choose your preferred location(s)"
            :menu-props="{ offsetY: true }"
            item-text="address"
            item-value="id"
            persistent-hint
            return-object
            multiple
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :color="themes.candidate.light.cancel" flat @click.native="locationDialog = false">
            Cancel
          </v-btn>
          <v-btn :color="themes.candidate.light.primaryActionButton" @click="update">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Vue Component
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      locationDialog: false,
      // Model
      selectLocation: JSON.parse(JSON.stringify(this.value.locations)),
    }
  },
  methods: {
    toggle() {
      this.locationDialog = !this.locationDialog
    },

    update() {
      this.$store
        .dispatch('candidate/applications/update', {
          id: this.value.id,
          locations: this.selectLocation,
        })
        .then(() => (this.locationDialog = false))
    },
  },
}
</script>
